const emailRegexp = /^[^\s@]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z]{2,})+$/;

export const isValidEmail = (url: string): boolean => {
  return emailRegexp.test(url);
}
